module.exports = __webpack_public_path__ + "img/Gate01_Frosunda_black.06042b7f.png";